import { render, staticRenderFns } from "./page-footer-mini.vue?vue&type=template&id=4e093d2a&scoped=true"
import script from "./page-footer-mini.vue?vue&type=script&lang=js"
export * from "./page-footer-mini.vue?vue&type=script&lang=js"
import style0 from "./page-footer-mini.vue?vue&type=style&index=0&id=4e093d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e093d2a",
  null
  
)

export default component.exports